import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import configurationServices from '@/configuration/services/services'

export const servicesByConfigurationMode = {
  [configurationTypes.merchant]: {
    getEmailTemplates: configurationServices.getMerchantEmailTemplates,
  },
  [configurationTypes.returnsPortal]: {
    getEmailTemplates: configurationServices.getPortalEmailTemplates,
  },
}
